
import EventItemV2 from '@/components/events/event-item';

export default class EventItemV2Full extends EventItemV2 {}
